import styled from 'styled-components'
export const StyledCheckboxArea = styled.div<{
  $direction: 'horizontal' | 'vertical'
  $maxHeight: string
}>`
  &.checkbox-area {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;

    .checkbox-area-label {
      align-self: stretch;
      color: var(--text-gray-strong);
      display: flex;
      gap: 0.4rem;

      /* label/label-medium-400 */
      font: var(--label-medium-400);
    }
    .required {
      color: var(--sys-red-1);

      /* label/label-medium-400 */
      font: var(--label-medium-400);
    }

    .checkbox-area-content {
      box-sizing: border-box;
      width: 100%;
      overflow: auto;
      display: flex;
      padding: 0.9rem 1.2rem;
      justify-content: start;
      gap: 1.6rem;
      border-radius: 0.4rem;
      border: 0.1rem solid var(--bg-gray-2);
      background: var(--bg-gray-normal);

      max-height: ${({ $maxHeight }) => $maxHeight};
      flex-direction: ${({ $direction }) => ($direction === 'vertical' ? 'column' : 'row')};
      flex-wrap: ${({ $direction }) => ($direction === 'vertical' ? 'nowrap' : 'wrap')};
      gap: ${({ $direction }) => ($direction === 'vertical' ? '0.8rem' : '1.6rem')};
    }
  }
`
